import PropTypes from "prop-types";
import shortid from "shortid";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import MenuItem from "../../menu/MenuItem";
import InputDropDown from "../../inputFields/dropdown/InputDropDown";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import InputText from "../../inputFields/InputText";
import Grid from "@mui/material/Grid2";

class StepConfiguration extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedTemplate: this.props.configurations.getTemplate(),
      selectedSendFromAddress: this.props.configurations.getSendFromAddress(),
      sendFromAddressName: this.props.configurations.getSendFromText(),
    }
  }

  onChangeSendFromMailText = (e, id, data) => {
    this.state.sendFromAddressName = data;
    this.props.configurations.setSendFromText(data);
  }

  onChangeSendFromMailAddress = (e, id, option) => {
    this.props.configurations.setSendFromAddress(option);
    this.setState({selectedSendFromAddress: option});
  }

  onTemplateDropDownChange = (e, id, data) => {
    this.props.configurations.setTemplate(data);
    this.setState({selectedTemplate: data});
  }

  createTemplatesDropDown(selectedTemplate) {
    let templates = this.props.configurations.getTemplates();
    let options = Array.from(templates).map(
      template => (<MenuItem key={shortid()} value={template}>{template}</MenuItem>));
    return <InputDropDown
      defaultValue={selectedTemplate}
      labelElement={'Template'}
      key={shortid()}
      onChange={this.onTemplateDropDownChange}>
      {options}
    </InputDropDown>
  }

  createFromAddressDropDown(selectedSendFromAddress) {
    let mailAddresses = this.props.configurations.getSendFromAddressOptions();
    let options = Array.from(mailAddresses).map(
      mailAddress => (<MenuItem key={shortid()} value={mailAddress}>{mailAddress}</MenuItem>));

    return <InputDropDown
      defaultValue={selectedSendFromAddress}
      labelElement={'Absender Adresse'} key={shortid()}
      onChange={this.onChangeSendFromMailAddress}>
      {options}
    </InputDropDown>;
  }

  render() {

    let {sendFromAddressName, selectedTemplate, selectedSendFromAddress} = this.state;
    return <HorizontalLayout className='gap-3 h-full'>
      <VerticalLayout className='gap-3'>
        {this.createTemplatesDropDown(selectedTemplate)}
        <InputText key={shortid()}
                   defaultValue={sendFromAddressName}
                   labelElement='Absender Name'
                   onChange={this.onChangeSendFromMailText}/>
        {this.createFromAddressDropDown(selectedSendFromAddress)}
      </VerticalLayout>
      <VerticalLayout>
        <h3>Konfiguration</h3>
        <Grid container spacing={1}>
          <Grid size={3}>Template:</Grid>
          <Grid size={9}>{selectedTemplate}</Grid>

          <Grid size={3}>Name:</Grid>
          <Grid size={9}>{sendFromAddressName}</Grid>

          <Grid size={3}>Mailadresse:</Grid>
          <Grid size={9}>{selectedSendFromAddress}</Grid>
        </Grid>
      </VerticalLayout>
    </HorizontalLayout>

  }
}

StepConfiguration.propTypes = {
  configurations: PropTypes.any.isRequired,
}
export default StepConfiguration;
